/**
 *
 * PluginIcon
 *
 */

import React from 'react';
import Puzzle from '@strapi/icons/Puzzle';
const PluginIcon = () => /*#__PURE__*/React.createElement(Puzzle, null);
export default PluginIcon;